export default __webpack_public_path__ + "static/media/menCoatWest.202136b4.svg";